import { Box } from '@components/ui/atoms/Box';
import { List } from '@components/ui/atoms/List';
import { Stack } from '@components/ui/atoms/Stack';
import { Text } from '@components/ui/atoms/Text';
import { memo } from 'react';

import { useMenuStructure } from './hooks';
import { MenuItem } from './MenuItem';

interface MenuProps {
  isExpanded: boolean;
}

export const Menu: React.FC<MenuProps> = memo(({ isExpanded }) => {
  const menustructure = useMenuStructure();

  return (
    <Stack
      display="flex"
      flexDirection="column"
      alignItems={isExpanded ? 'flex-start' : 'center'}
      gap="24px"
    >
      <Box w="full" padding={isExpanded ? '0 24px' : '0 12px'}>
        <Text
          fontSize="12px"
          fontWeight="500"
          textTransform="uppercase"
          color="body.dark"
          borderBottom="1px solid"
          borderColor="body.550/10"
          pb={1}
          textAlign="start"
          textWrap="nowrap"
        >
          Payment
        </Text>
      </Box>
      <List w="full" as="ol" display="grid" gap="0" data-test-id="menu-list">
        {menustructure.map((menuItem) => (
          <MenuItem key={menuItem.id} menuItem={menuItem} isExpanded={isExpanded} />
        ))}
      </List>
    </Stack>
  );
});

Menu.displayName = 'Menu';
